import { useMutation } from '@apollo/client';
import React from 'react';
import UIActions from '../../ui/UIActions';
import updateQueryList from '../../utils/graphql/updateQueryList';
import { useRouter } from '../../utils/router/v3Bridge';
import type { WebhookValues } from './AdminWebhookForm';
import AdminWebhookForm from './AdminWebhookForm';
import { ALL_WEBHOOKS_QUERY } from './AdminWebhooksView';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';

const CREATE_WEBHOOK_MUTATION = gql(`
  mutation createWebhook(
    $enableAllPosts: Boolean
    $events: [WebhookEvent!]!
    $name: String!
    $targetUrl: String!
    $topics: [ID!]
  ) {
    createWebhook(
      enableAllPosts: $enableAllPosts
      events: $events
      name: $name
      targetUrl: $targetUrl
      topics: $topics
    ) {
      id
      name
      targetUrl
      secret
    }
  }
`);

const AdminWebhookNewView = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const [createWebhook] = useMutation(CREATE_WEBHOOK_MUTATION);

  const handleSubmit = async (values: WebhookValues) => {
    const { data } = await createWebhook({
      variables: values,
      update: updateQueryList(
        { query: ALL_WEBHOOKS_QUERY },
        'session.organization.webhooks',
        'createWebhook',
      ),
    });
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    router.push(`/admin/developer/webhooks/${data?.createWebhook?.id}`);
    dispatch(
      UIActions.pushToast({
        level: 'success',
        message: 'Webhook successfully created',
      }),
    );
  };

  return <AdminWebhookForm onSubmit={handleSubmit} />;
};

export default AdminWebhookNewView;
